module.exports = __webpack_public_path__ + "resources/img/img_dsm1_jp.0e436236fa7207416fc35adb4dcca3c2.png";